import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';

const AddAgence = ({ isVisible = true, onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [zones, setZones] = useState([]);
    const [selectedZone, setSelectedZone] = useState(null);
    const [inputValueZone, setValueZone] = useState('');

    const [agence, setAgence] = useState({
        nom: '',
        adresse: '',
        tel: '',
        ville: '',
        zone: '',

    });
    const handleInputChangeZone = value => {
        setValueZone(value);
    };

    // handle selection


    // handle selection
    const handleChangeZone = value => {
        setSelectedZone(value);
        setAgence({ ...agence, zone: value.id });

    }

    const getZones = () => {
        axiosClient.get('/zones')
            .then((data) => {
                setZones(data.data.zones);
            })
    }

    useEffect(() => {
        getZones();
    }, []);


    const navigate = useNavigate();

    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.post('/agence/save', agence)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations obligatoires!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    if (!isVisible) {
        return null
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className=''>
                            <Header title="Ajouter une agence" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }

                        <>
                            <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-3'>
                                <div className='flex-col w-full justify-evenly '>
                                    <div className='mr-2'>
                                        <Input label="Nom" type="text" value={agence.nom} onChange={ev => setAgence({ ...agence, nom: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Adresse" type="text" value={agence.adresse} onChange={ev => setAgence({ ...agence, adresse: ev.target.value })} />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Tel" type="text" value={agence.tel} onChange={ev => setAgence({ ...agence, tel: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Ville" type="text" value={agence.ville} onChange={ev => setAgence({ ...agence, ville: ev.target.value })} required="required" />
                                    </div>
                                    <div className='flex-col w-full justify-evenly '>
                                        <div className="flex-col w-full">
                                            <label className="block text-sm font-medium leading-6 text-gray-900">Zone <span className='text-red-500'> *</span></label>
                                            <Select className='mt-2 outline-1 ' placeholder="Zone" cacheOptions defaultOptions value={selectedZone} getOptionLabel={e => e.nom} getOptionValue={e => e.id} options={zones} onInputChange={handleInputChangeZone} onChange={handleChangeZone} />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </>


                        <div className='flex  justify-end items-end'>
                            {loading ? <Loading /> :
                                <div className=' flex gap-3 m-2  justify-between'>
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                    <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddAgence